import { useAppDispatch, useAppSelector } from '@/state/store';
import { setShouldShowGuestSignUpModal } from '@/state/features/app';
import { useTheme } from '@/theme';
import { sendEvent } from '@/utils/analytics';
import Modal from '@/components/Modal';
import MarkdownRenderer from '@/components/MarkdownRenderer';
import ThemedButton from '@/components/ThemedButton';
import { isHomePath } from '@/theme/vars';
import { useCurrentUserIsGuest } from '@/hooks/users';
import { useNavigateToSignup } from '@/hooks/auth';

import * as styles from './styles.module.scss';

export default function GuestSignUpModal() {
    const isGuest = useCurrentUserIsGuest();
    const navigateToSignup = useNavigateToSignup();
    const theme = useTheme();
    const dispatch = useAppDispatch();
    const hasData = theme.metadata?.guestModalMarkdown;

    const guestModalCount = useAppSelector((state) => state.app.guestModalCount);
    const shouldShowGuestSignUpModal = useAppSelector((state) => state.app.shouldShowGuestSignUpModal);

    if (!isGuest || !hasData || !isHomePath()) return;

    // Only show modal every other time it is requested by app
    const shouldShow = shouldShowGuestSignUpModal && guestModalCount % 2 !== 0;
    if (shouldShow) {
        sendEvent('view_guest_signup_modal');
    }

    return (
        <Modal
            modalClassname={styles.GuestSignUpModal}
            zIndex={1000}
            onClose={() => {
                dispatch(setShouldShowGuestSignUpModal(false));
                sendEvent('close_guest_signup_modal');
            }}
            isVisible={shouldShow}
            canScroll={true}
            leaveSpaceAboveAndBelow={false}
        >
            <MarkdownRenderer base64MarkdownContent={theme.metadata?.guestModalMarkdown} />
            <ThemedButton
                className={styles.joinButton}
                onClick={() => {
                    sendEvent('signup_guest_signup_modal');
                    navigateToSignup();
                }}
                text="Sign Up"
            />
        </Modal>
    );
}
